import React from "react"

import ContainerInsurance from "./ContainerInsurance"

const Insurance = () => {
  return <ContainerInsurance />
}

export default Insurance
